export const environment = {
    production: false,
    selectedLanguageCulture: "en",
    baseUrl: window.location.origin,
    apis: {
        default: {
            url: `${window.location.origin}/api/v1`,
            rootNamespace: 'croo',
        },
        legacy: {
            url: "https://api.croo.io/v1"
        },
        azureFunction: {
            url: "https://apidevazapp.mycroo.io/wapi"
        },
        hangfire: {
            url: `${window.location.origin}/jobs`
        }
    },
    awscognito: {
        userPoolId: "us-east-1_sCUHdFnnD",
        userPoolClientId: "a421ucnajl9sr37phokvvu1m2",
        identityPoolId: "us-east-1:54f823d7-ebfe-429f-b24d-94b1b530fe0d"
    },
    b2cCognitoConfig: {
        domain: "https://croossoprod1.auth.us-east-1.amazoncognito.com",
        clientId: "3lg5opnodi8pf6l666pehqr7te",
        redirectUri: "https://croocoredev.b2clogin.com/croocoredev.onmicrosoft.com/oauth2/authresp",
        scope: "openid+email+phone"
    },
    b2cConfig: {
        b2cPolicies: {
             names: {
                signUp: "B2C_1_MyCroo_SignUp_Dev06",
                signIn: "B2C_1_MyCroo_SignUp_SignIn_Dev06",
            }
        },
        msalConfig: {
            auth: {
                clientId: '55578d69-d381-4761-bc75-0dd98b9a5095',
                domain: "croocoredev"

            }
        },
        protectedResources: {
            crooListApi: {
                endpoint: `${window.location.origin}/api/v1`,
                scopes: ["https://croocoredev.onmicrosoft.com/tasks-api/tasks.read",
                    "https://croocoredev.onmicrosoft.com/tasks-api/tasks.write"
                ],
            },
        },
        loginRequest: {
            scopes: ["openid"]
        }
    }
};